export const formatCurrency = ({ language = 'en', currency = 'USD', amount = 0 }) => {
  const currencyFormatter = Intl.NumberFormat(language, {
    style: 'currency',
    currency,
    useGrouping: true,
  });
  return currencyFormatter.format(amount);
};
